<template>
  <el-drawer
    class="component-detail-drawer"
    size="80%"
    :visible="selfVisible"
    direction="rtl"
    @update:visible="visibleChange"
    :title="$t('components_index.bu_jian_xiang_qing')"
  >
    <div class="drawer-body">
      <div
        class="component-param"
        v-if="tabShowConfig.base"
      >
        <div class="component-name">
          {{ $t('components_index.bu_jian_xin_xi') }}
        </div>
        <ul class="param-detail">
          <li v-if="model.componentName">
            <div class="key">
              {{ $t('components_index.bu_jian_ming_cheng') }}
            </div>
            <div class="val">{{ model.componentName }}</div>
          </li>
          <li
            v-for="(item, index) in data"
            :key="index"
          >
            <div class="key">{{ item.dataName }}</div>
            <div class="val" v-if="item.unit&&item.unit.indexOf('℃')> -1">{{ item.dataValue&&item.dataValue!=="null"?$celsiusToFahrenheit(item.dataValue):'-' }}{{item.unit.replace('℃',$formatTempUnit()) || ''}}</div>
            <div class="val" v-else-if="item.dicGroup">{{getDicValue(item.dicGroup, item.dataValue)}}</div>
            <div class="val" v-else>{{ item.dataValue&&item.dataValue!=="null"?item.dataValue:'-' }}{{item.unit || ''}}</div>
          </li>
        </ul>
      </div>
      <div class="tab-container">
        <div
          class="status-tips"
          v-if="faultData.faultInfoId"
          @click="onFaultMore(faultData)"
          :class="{warning: model.isWarning}"
        >
          <div class="status-icon">
            <i class="icon icon-warning1"></i>
          </div>
          <div class="tips-text">
            <div class="tips">
              {{ faultData.faultName || faultData.faultDesc }}
              <!-- {{ faultData.faultName }} -->
            </div>
            <div class="plan">
              {{ $t('components_index.gu_zhang_dai_ma') }}：{{
                faultData.faultCode || '-'
              }},
              {{ $t('components_index.ji_qi_dai_ma') }}：{{
                faultData.customerCode|| '-'
              }}

            </div>

          </div>
          <div class="right-icon">
            <i class="icon icon-you"></i>
          </div>

        </div>
        <custom-tab
          v-if="tabData.length"
          :list="tabData"
          v-model="tabIndex"
          class="tab"
          :class="{ offset: faultData.faultInfoId }"
        ></custom-tab>
        <div
          class="tab-content"
          v-if="tabData.length"
        >
          <!-- 状态信息 -->
          <detail-status
            v-if="tabIndex === 0"
            :model="model"
            :showChart="tabShowConfig.current"
            ref="status"
          ></detail-status>
          <!-- 状态数据明细 -->
          <detail-data
            v-if="tabIndex === 1"
            :model="model"
          ></detail-data>
          <!-- 事件记录 -->
          <detail-record
            v-if="tabIndex === 2"
            :model="model"
          ></detail-record>
          <!-- 故障记录 -->
          <!-- <detail-fault v-if="tabIndex === 3" :model="model"></detail-fault> -->
          <!-- 基础历史 -->
          <detail-base-history
            v-if="tabIndex === 4"
            :model="model"
          ></detail-base-history>
        </div>
      </div>
      <device-detail-fault-more
        v-if="dialogVisible"
        :model="dialogModel"
        @close="dialogVisible = false"
      >
      </device-detail-fault-more>
    </div>
  </el-drawer>
</template>

<script>
import apis from '@/utils/apis.js';
import languageInjectMixins from '@/mixins/language_inject_mixins';
import deviceDetailFaultMore from '@/pages/dms/components/device_detail_fault_more.vue';
import detailData from './component_detail_data.vue';
import detailRecord from './component_detail_record.vue';
import detailStatus from './component_detail_status.vue';
import detailBaseHistory from './component_detail_base_history.vue';

export default {
  mixins: [languageInjectMixins],

  components: {
    detailStatus,
    detailData,
    detailRecord,
    detailBaseHistory,
    deviceDetailFaultMore
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    tabData() {
      let ret = [
        {
          name: this.$t('components_index.shi_shi_xin_xi'),
          value: 0,
          type: 'base'
        },
        {
          name: this.$t('components_index.shi_shi_ji_lu'),
          value: 1,
          type: 'realtimeHist'
        },
        {
          name: this.$t('components_index.shi_jian_ji_lu'),
          value: 2,
          type: 'event'
        },
        {
          name: this.$t('components_index.ji_chu_ji_lu'),
          value: 4,
          type: 'hist'
        }
      ];
      ret = ret.filter(item => this.tabShowConfig[item.type]);

      return ret;
    }
  },
  data() {
    return {
      // provide: true,
      selfVisible: false,
      tabIndex: 0,
      data: [],
      faultData: {},
      fileList: [],
      // 显示配置
      tabShowConfig: {
        // 左侧基本参数
        base: true,
        // 事件/故障记录
        event: true,
        // 基础历史
        hist: true,
        // 状态信息
        realtime: true,
        // 状态数据明细
        realtimeHist: true,
        // 是否显示状态信息图标
        current: true
      },
      dialogVisible: false,
      dialogModel: {}
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.selfVisible = val;
      }
    },
    tabData(val) {
      if (val && val.length) {
        this.tabIndex = val[0].value;
      }
    },
    tabIndex(val) {
      if (val === 0 && this.tabShowConfig.current) {
        this.$nextTick(() => {
          this.$refs.status.initChart();
        });
      }
    }
  },
  methods: {
    getShowConfig() {
      const reqData = {
        modemSn: this.model.modemSn,
        componentCode: this.model.componentCode
      };
      this.$getJSON(apis.modemBatteryTabShow, reqData).then((res) => {
        this.tabShowConfig = res.data;
        this.$refs.status.initChart();
      });
    },
    // 查看
    onFaultMore(row) {
      this.dialogModel.data = row;
      this.dialogVisible = true;
    },
    // getFileList() {
    //   const bizId = this.faultData.faultInfoId;
    //   const bizType = 'eventItemDialog';
    //   const url = `${apis.OssAttach}/${bizId}/${bizType}`;
    //   this.$getJSON(url).then((res) => {
    //     this.fileList = res.data;
    //   });
    // },
    // 最新异常信息
    // getFaultData() {
    //   return this.$getJSON(apis.DeviceResumeComponentNewFault, {
    //     modemSn: this.model.modemSn,
    //     componentCode: this.model.componentCode
    //   }).then((res) => {
    //     this.faultData = res.data || {};
    //   });
    // },
    visibleChange(val) {
      if (val) {
        this.$emit('update:visible', val);
      } else {
        this.selfVisible = false;
        setTimeout(() => {
          this.$emit('update:visible', val);
        }, 300);
      }
    },
    getData() {
      this.$getJSON(apis.modemBatteryComponentBase, {
        modemSn: this.model.modemSn,
        componentCode: this.model.componentCode
      }).then((res) => {
        this.data = res.data;
      });
    },
  },
  mounted() {
    this.getData();
    this.getShowConfig();
  }
};
</script>

<style lang="scss">
.component-detail-drawer {
  .drawer-body {
    display: flex;
    width: 100%;
    height: 100%;
    .component-param {
      width: 300px;
      background: #f8f9fb;
      font-family: PingFangSC-Semibold, PingFang SC;
      padding: 0 26px 0 24px;
      flex-shrink: 0;
      overflow-y: auto;

      .component-name {
        color: #495057;
        font-size: 14px;
        font-weight: bold;
        line-height: 60px;
      }

      .param-detail {
        margin-top: 4px;
        line-height: 16px;
        color: #6c757d;
        font-size: 12px;
        > li {
          overflow: hidden;
          padding: 10px 0;
          &:nth-child(n + 2) {
            margin-top: 1px;
          }
          .key,
          .val {
            float: left;
          }
          .key {
            width: 40%;
          }
          .val {
            width: 60%;
          }
          .val {
            text-align: right;
          }
          border-bottom: 1px solid #eef2f7;
        }
      }
    }
    .tab-container {
      flex: 1;
      background: #fff;
      padding: 24px;
      display: flex;
      flex-direction: column;
      overflow-x: auto;
      padding-bottom: 0;
      .status-tips {
        height: 61px;
        width: 100%;
        background: #ff5c5b;
        color: #f8f9fb;
        margin-top: 16px;
        cursor: pointer;
        .status-icon {
          $r: 36px;
          width: $r;
          height: $r;
          margin-top: 13px;
          margin-left: 12px;
          float: left;
          .icon {
            color: #f8f9fb;
            font-size: 32px;
          }
        }
        .right-icon {
          $r: 36px;
          width: 30px;
          height: $r;
          margin-top: 13px;
          margin-left: 12px;
          float: right;
          .icon {
            color: #f8f9fb;
            font-size: 16px;
            line-height: 36px;
          }
        }
        .tips-text {
          float: left;
          margin-left: 10px;
          .tips {
            font-size: 12px;
            font-weight: bold;
            line-height: 17px;
            margin-top: 13px;
          }
          .plan {
            font-size: 12px;
            margin-top: 2px;
          }
        }
      }
      .warning {
        background: #f9c851;
      }
      .download-content {
        overflow: hidden;
        padding: 16px 0;
        padding-bottom: 0;
        line-height: 16px;
        font-size: 12px;
        .file-list {
          float: left;

          .download {
            color: #0d9ae0;
            &:nth-child(n + 2) {
              margin-top: 10px;
            }
            .file-name {
              padding-left: 4px;
            }
          }
        }

        .date {
          color: #6c757d;
          float: right;
        }
      }
      .tab {
        &.offset {
          margin-top: 40px;
        }
        ul li {
          border-top: 1px solid #eef2f8;
          line-height: 40px;
          &:nth-child(1) {
            border-left: 1px solid #eef2f8;
          }
          &.current {
            border-top: 2px solid #0d9ae0;
            line-height: 39px;
          }
        }
        .ub-f1 {
          border-top: none;
        }
      }
      .tab-content {
        flex: 1;
        overflow-y: auto;
      }
    }
  }

  .el-drawer__body {
    overflow-y: auto;
  }
}
</style>
